<template>
    <Wrapper>
        <Breadcrumb :items="breadcrumbItems" />

        <div class="grid grid-cols-12 base-responsive-gap mt-6">
            <div class="col-span-12">
                <h1 class="header-1 mb-4">{{ model.name }}</h1>
            </div>

            <div class="col-span-12 lg:col-span-4">
                <div class="p-8 bg-white">
                    <div v-if="model.keywords" class="font-bold uppercase"><T t="career.field" /></div>
                    <div v-if="model.keywords">{{ model.keywords }}</div>
                    <div v-if="model.requirement" class="font-bold uppercase mt-4"><T t="career.experience" /></div>
                    <div v-if="model.requirement">{{ model.requirement }}</div>
                    <div v-if="model.location" class="font-bold uppercase mt-4"><T t="career.location" /></div>
                    <div v-if="model.location">{{ model.location }}</div>
                    <div v-if="model.type" class="font-bold uppercase mt-4"><T t="career.work_hours" /></div>
                    <div v-if="model.type">{{ model.type }}</div>
                </div>
            </div>
            <div class="col-span-12 lg:col-span-8">
                <div class="font-bold" v-html="model.lead"></div>
                <EditableContentComponentGroup :components="model.components" has-parent-container class="mt-12" />
            </div>
        </div>
    </Wrapper>
</template>

<script>
import Wrapper from '@/components/Pages/Docs/Wrapper.vue';
import EditableContentComponentGroup from '@/components/Generic/EditableContentComponentGroup.vue';

export default {
    name: 'Position',
    components: {
        Wrapper,
        EditableContentComponentGroup,
    },
    async asyncData({ $axios, params, redirect, localePath, i18n }) {
        let model = null;

        await $axios
            .$get(`/careers/by-slug/${params.position}`)
            .then((res) => {
                model = res;
            })
            .catch((err) => {
                console.log(err);
            });

        if (!model) {
            return await redirect(307, localePath('career'));
        }

        await i18n.generateLocalizedRouteParams(model.locale_variants, 'position');

        const breadcrumbItems = [];

        breadcrumbItems.push([i18n.t('career.title'), 'career']);
        breadcrumbItems.push([model.name, 'position']);

        return {
            breadcrumbItems,
            model,
        };
    },
    head() {
        return {
            title: this.$getPageTitle(this.model.metadata),
            meta: this.$getPageMetaData(this.model.metadata),
        };
    },
};
</script>

<style scoped></style>
